export enum StepButtonType {
  NORMAL,
  TEXT,
}
